export default "__VITE_ASSET__DR_rTK5j__"